export default {"src":"/_next/static/media/stars.9df96d97.svg","height":20,"width":104,"blurWidth":0,"blurHeight":0};